import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from 'components/common/Logo';
import Section from 'components/common/Section';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
          <Logo width={'250px'} />
          <Card className="text-center">
            <Card.Body className="p-5">
              <div className="display-1 text-300 fs-error">404</div>
              <p className="lead mt-4 text-800 font-sans-serif fw-semiboFld">
                Pagina non trovata
              </p>
              <hr />
              <p>
                La pagina che cerchi potrebbe essere spostata o non esistere
                più. Se pensi sia un errore,{' '}
                <a href="mailto:fantaclasse.it@gmail.com">contattaci</a>.
              </p>
              <Link className="btn btn-primary btn-sm mt-3" to="/">
                <FontAwesomeIcon icon={faHome} className="me-2" />
                Torna alla Home
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default Error404;
